module.exports = __webpack_public_path__ + "static/media/new_armory_white_logo.0cfe9ed7.png";